import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMomentumSpikesSurge = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M24.6606 3.2209C25.2488 2.82305 26.0481 2.9773 26.4459 3.56544L32.9294 13.1497C33.3273 13.7379 33.173 14.5372 32.5849 14.935C31.9968 15.3329 31.1975 15.1786 30.7996 14.5905L26.0553 7.57716L21.4054 31.6719C21.3174 32.128 20.9902 32.5011 20.5496 32.648L7.69262 36.9337C7.01899 37.1582 6.29087 36.7942 6.06633 36.1205C5.84178 35.4469 6.20584 34.7188 6.87947 34.4942L19.0231 30.4464L23.5305 7.08991L16.5171 11.8342C15.929 12.2321 15.1297 12.0778 14.7318 11.4897C14.334 10.9016 14.4882 10.1023 15.0764 9.70439L24.6606 3.2209Z"
	})
});
export default SvgMomentumSpikesSurge;
